class ViewController {
    constructor($http, $sce, authService, myBookingService, sharedService, cacheService) {
        'ngInject';
        this.name = 'view';
        this.$sce = $sce;
        this.$http = $http;
        this.myBookingService = myBookingService;
        this.authService = authService;
        this.cacheService = cacheService;
        this.IS_MOBILE = sharedService.IS_MOBILE;
        this.showIframe = false;
        this.showPdfNotFoundError = false;
        this.lastPdfVoucherUrl = null;
        this.successCallback = this.successCallback.bind(this);
        this.errorCallback = this.errorCallback.bind(this);
    }

    getLastPdfVoucherUrl() {
        const agencyBookingReference = this.cacheService.get('agencyBookingReference');
        return this.myBookingService.getLastPdfVoucherUrl(
            agencyBookingReference,
            this.authService.getAccessToken(),
            true
        );
    }

    successCallback() {
        this.lastPdfVoucherUrl = this.$sce.trustAsResourceUrl(this.getLastPdfVoucherUrl());
        this.showIframe = true;
    }

    errorCallback() {
        this.showIframe = false;
        this.showPdfNotFoundError = true;
    }

    $onInit() {
        this.$http({
            method: 'HEAD',
            url: this.getLastPdfVoucherUrl()
        }).then(this.successCallback, this.errorCallback);
    }
}

export default ViewController;



// WEBPACK FOOTER //
// ./client/app/routes/onTheBeach/booking/view/view.controller.js